"use client";

import { useEffect, useMemo, useState } from "react";
import { BookOpen, Search, Tags, UserRound, X } from "lucide-react";
import { useRouter, useSearchParams } from "next/navigation";
import styles from "styles/components/books-search.module.css";

const tabs = [
  { key: "all", label: "Бүгд", icon: BookOpen },
  { key: "topics", label: "Сэдвүүд", icon: Tags },
  { key: "authors", label: "Зохиолчид", icon: UserRound },
];

const BooksSearchBar = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [active, setActive] = useState("all");
  const [query, setQuery] = useState("");
  const activeTab = useMemo(
    () => tabs.find((tab) => tab.key === active) || tabs[0],
    [active],
  );

  useEffect(() => {
    const nextActive = searchParams?.get("type") || "all";
    const nextQuery = searchParams?.get("q") || "";
    setActive(nextActive);
    setQuery(nextQuery);
  }, [searchParams]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (!trimmed) {
      router.push("/books");
      return;
    }
    const params = new URLSearchParams();
    params.set("q", trimmed);
    params.set("type", active || "all");
    router.push(`/books?${params.toString()}`);
  };

  const handleClear = () => {
    setQuery("");
    router.push("/books");
  };

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.shell}>
          <div className={styles.heading}>
            <h2 className={styles.title}>Ном хайх</h2>
          </div>

          <form className={styles.bar} onSubmit={handleSubmit}>
            <div className={styles.tabs} aria-label="Хайлтын төрөл">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    className={`${styles.tabButton} ${
                      active === tab.key ? styles.tabButtonActive : ""
                    }`}
                    onClick={() => setActive(tab.key)}
                  >
                    <Icon size={15} />
                    {tab.label}
                  </button>
                );
              })}
            </div>

            <div className={styles.searchRow}>
              <div className={styles.searchGroup}>
                <Search size={18} className={styles.searchIcon} />
                <input
                  type="search"
                  className={styles.searchInput}
                  placeholder={`${activeTab.label.toLowerCase()} дундаас хайх...`}
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  aria-label="Номнуудаас хайх"
                />
                {query && (
                  <button
                    type="button"
                    className={styles.clearButton}
                    onClick={handleClear}
                    aria-label="Хайлтыг цэвэрлэх"
                  >
                    <X size={15} />
                  </button>
                )}
              </div>
              <button type="submit" className={styles.searchButton}>
                Хайх
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BooksSearchBar;
